import { createStyles, Group, Menu, Tooltip } from '@mantine/core';
import { Button, Icon, Text } from '@repo/foundations';
import { useNavigate } from 'react-router';
import { usePlan } from '../../../../hooks/usePlans';
import { useFeatureFlags } from '../../../../utils/featureFlags';
import { useIntercomWithDomainCheck } from '../../../../utils/useIntercomWithDomainCheck';

const HELP_CENTER_URL =
	'https://avp-team.atlassian.net/servicedesk/customer/portal/2272';
const DOCS_URL = 'https://docs.secoda.co';

const useStyles = createStyles((theme) => ({
	targetButton: {
		pointerEvents: 'auto',
		width: theme.other.space[7],
		height: theme.other.space[7],
		borderRadius: '50%',
		backgroundColor: theme.other.getColor('fill/secondary/default'),
		'&:hover': {
			backgroundColor: theme.other.getColor('fill/secondary/hover'),
		},
		'&:active': {
			backgroundColor: theme.other.getColor('fill/secondary/active'),
		},
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	dropdown: {
		pointerEvents: 'auto',
	},
}));

export function HelpMenu() {
	const { classes } = useStyles();
	const { boot, show, hide, isOpen } = useIntercomWithDomainCheck();
	const { isPayingCustomer } = usePlan();
	const { jsmHelpMenu } = useFeatureFlags();
	const navigate = useNavigate();

	if (!isPayingCustomer) {
		return null;
	}

	if (!jsmHelpMenu) {
		const handleHelpClick = async () => {
			if (isOpen) {
				hide();
			} else {
				await boot();
				show();
			}
		};

		return (
			<Button className={classes.targetButton} onClick={handleHelpClick}>
				<Tooltip label="Help and resources">
					<Icon name="questionMark" size="md" />
				</Tooltip>
			</Button>
		);
	}

	return (
		<Menu
			position="top-start"
			offset={4}
			withArrow={false}
			classNames={{ dropdown: classes.dropdown }}
		>
			<Menu.Target>
				<Button className={classes.targetButton}>
					<Tooltip label="Help and resources">
						<Icon name="questionMark" size="md" />
					</Tooltip>
				</Button>
			</Menu.Target>
			<Menu.Dropdown>
				<Menu.Item
					component="a"
					href={HELP_CENTER_URL}
					target="_blank"
					rel="noopener noreferrer"
				>
					<Group spacing="xs" position="apart" noWrap>
						<Group spacing="xs" noWrap>
							<Icon name="lifebuoy" color="icon/primary/default" />
							<Text size="sm">Help Center</Text>
						</Group>
						<Icon name="externalLink" color="icon/secondary/default" />
					</Group>
				</Menu.Item>
				<Menu.Item
					component="a"
					href={DOCS_URL}
					target="_blank"
					rel="noopener noreferrer"
				>
					<Group spacing="xs" position="apart" noWrap>
						<Group spacing="xs" noWrap>
							<Icon name="book" color="icon/primary/default" />
							<Text size="sm">Docs</Text>
						</Group>
						<Icon name="externalLink" color="icon/secondary/default" />
					</Group>
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item onClick={() => navigate('/settings')}>
					<Group spacing="xs" noWrap>
						<Icon name="settings" color="icon/primary/default" />
						<Text size="sm">Settings</Text>
					</Group>
				</Menu.Item>
			</Menu.Dropdown>
		</Menu>
	);
}
